import * as React from 'react';
import { WidgetTypeWrapper } from 'services/WidgetTypes/WidgetTypeWrapper';
import IndexedList from 'models/Collections/IndexedList';

// HyperSpaceColumnChartWidget
import { HyperSpaceColumnChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/options';
import { HyperSpaceColumnChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/tunables';
const HyperSpaceColumnChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceColumnChartWidget" */ '../../widgets/hyperSpace/HyperSpaceColumnChartWidget/HyperSpaceColumnChartWidget'
    )
);

// HyperSpaceBarChartWidget
import { HyperSpaceBarChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceBarChartWidget/options';
import { HyperSpaceBarChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceBarChartWidget/tunables';
const HyperSpaceBarChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceBarChartWidget" */ '../../widgets/hyperSpace/HyperSpaceBarChartWidget/HyperSpaceBarChartWidget'
    )
);

// HyperSpaceLineChartWidget
import { HyperSpaceLineChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpaceLineChartWidget/options';
import { HyperSpaceLineChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpaceLineChartWidget/tunables';
const HyperSpaceLineChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpaceLineChartWidget" */ '../../widgets/hyperSpace/HyperSpaceLineChartWidget/HyperSpaceLineChartWidget'
    )
);

// HyperSpacePieChartChartWidget
import { HyperSpacePieChartWidgetOptionsImpl } from '../../widgets/hyperSpace/HyperSpacePieChartWidget/options';
import { HyperSpacePieChartWidgetTunables } from '../../widgets/hyperSpace/HyperSpacePieChartWidget/tunables';
const HyperSpacePieChartWidget = React.lazy(() =>
    import(
        /* webpackChunkName: "HyperSpacePieChartWidget" */ '../../widgets/hyperSpace/HyperSpacePieChartWidget/HyperSpacePieChartWidget'
    )
);

export const addHyperSpaceCharts = (indexedList: IndexedList<WidgetTypeWrapper>) => {
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceBarChart',
            idTemplate: 'hyper-space-bar-chart',
            name: 'Bar Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceBarChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceBarChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-bar-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceBarChartWidgetTunables,
        })
    );

    // hyperSpaceColumnChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceColumnChart',
            idTemplate: 'hyper-space-column-chart',
            name: 'Column Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceColumnChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceColumnChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-column-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceColumnChartWidgetTunables,
        })
    );
    // hyperSpaceLineChart
    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpaceLineChart',
            idTemplate: 'hyper-space-line-chart',
            name: 'Line Chart - NEW',
            dataType: 'analytics',
            component: HyperSpaceLineChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 1,
            maxGroupBys: 2,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpaceLineChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-line-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpaceLineChartWidgetTunables,
        })
    );

    indexedList.add(
        new WidgetTypeWrapper({
            id: 'hyperSpacePieChart',
            idTemplate: 'hyper-space-pie-chart',
            name: 'Pie Chart - NEW',
            dataType: 'analytics',
            component: HyperSpacePieChartWidget,
            supportsWidgetLabelDateRange: true,
            tags: ['analytics'],
            minProjections: 1,
            maxProjections: 12,
            minGroupBys: 0,
            maxGroupBys: 1,
            supportsPanelPadding: true,
            supportsPreviousPeriod: true,
            groupByLabels: ['x', 'series'],
            optionsType: HyperSpacePieChartWidgetOptionsImpl,
            supportsWidgetLabel: true,
            supportsLabel: true,
            supportsColorPalette: true,
            supportsDisableColorPalette: true,
            supportsSpacingMax: 25,
            supportsPadding: true,
            supportsPaddingMin: 15,
            supportsPaddingMax: 35,
            // supportsAnimationTypes: ['fade', 'drop', 'lift', 'slide_in_out', 'scale_in_out'],
            supportsAnimationTunables: false,
            supportsAnimation: false,
            supportsAnimationDelay: false,
            supportsAnimationLength: false,
            supportsThresholds: true,
            supportsHistory: true,
            supportsBlacklist: true,
            thresholdType: 'multipleLine',
            supportsMainColor: true,
            supportsThemeTypography: true,
            supportsSentiment: true,
            thumbSrc: 'template-pie-chart.jpg',
            supportsThemeColor: true,
            supportsThemeImage: true,
            supportsThemeImageOpacity: false,
            supportsThemeImageCircleMask: true,
            supportsThemeImageSize: true,
            supportsThemeImagePosition: true,
            supportsSortBy: true,
            tunables: HyperSpacePieChartWidgetTunables,
        })
    );
};
